export default __webpack_public_path__ + "static/media/User-Avatar.319a6675.png";